/*  Leggere un numero da un campo di testo.

    Sta in un posto solo perché serviva in due — il pannello degli ordini e quello delle
    bolle — e le due copie non si comportavano allo stesso modo. `Number('')` in
    JavaScript fa **zero**, non NaN: un campo quantità lasciato vuoto diventava uno zero
    valido, e il riepilogo «verranno creati 2 ordini» contava una riga che poi la
    validazione rifiutava. Distinguere «vuoto» da «zero» non è pignoleria: è la
    differenza fra una riga che nessuno ha compilato e una riga che qualcuno ha messo a
    zero di proposito.

    La virgola è come si scrivono i decimali qui, quindi si accetta. Il punto anche,
    perché è quello che arriva dai campi numerici del browser.  */

/** Il numero scritto nel campo, o <c>null</c> se il campo è vuoto o non è un numero. */
export function numeroDecimale(testo: string | null | undefined): number | null {
  if (testo === null || testo === undefined) return null;

  const pulito = testo.trim().replace(',', '.');
  if (pulito === '') return null;

  const valore = Number(pulito);
  return Number.isFinite(valore) ? valore : null;
}

/** Comodo dove uno zero e un campo vuoto si possono trattare allo stesso modo. */
export function numeroDecimaleOZero(testo: string | null | undefined): number {
  return numeroDecimale(testo) ?? 0;
}
